export default __webpack_public_path__ + "static/media/data2.bd71ed07.svg";